import { useQuery } from 'react-query';
import { POST, getRecaptchaToken } from './http-service';
import { useClientStateDataUpdate } from 'hooks/clientStateData';
import isEqual from 'lodash/isEqual';

export const ServiceType = ({journeyGuid, lngCode, rcaEnabled, executeRecaptcha, clientStateData: currentClientStateData, useMock}) => {

  const baseApi = `${lngCode}`;
  const clientStateDataUpdate = useClientStateDataUpdate();

  return {
    useServiceTypeQuery (serviceTypeEnabled, hasRecaptcha, locationId, customerGUID, journeyGUID, appointmentTypeId, serviceId, serviceTypeId,calendarIds,selectedSlot,selectedDate, questionAnswerDict, rerender) {
      return useQuery(
        ['active-query', 'service-types', rerender ],
       ({ queryKey }) => getServiceTypes( hasRecaptcha, locationId, customerGUID, journeyGUID, appointmentTypeId, serviceId,serviceTypeId, calendarIds,selectedSlot,selectedDate, questionAnswerDict),
        { enabled: serviceTypeEnabled }
      );
    },
    useAppointmentTypesQuery  (appointmentTypeEnabled, canGetAppointmentTypes, hasRecaptcha, journeyGUID, serviceTypeId, locationId, customerGUID, appointmentTypeId, serviceId, calendarIds, selectedSlot, selectedDate, questionAnswerDict ) {
      return useQuery(
        ['active-query', 'appointment-types', serviceTypeId ],
        ({ queryKey }) => getAppointmentTypes(hasRecaptcha,journeyGUID, serviceTypeId, locationId, customerGUID, appointmentTypeId, serviceId,calendarIds, selectedSlot, selectedDate, questionAnswerDict ),
        { enabled: appointmentTypeEnabled && canGetAppointmentTypes }
      );
    },
  };

  //------------------------------------------------------------------------------------------------------------------//

  async function getServiceTypes (hasRecaptcha, locationId, customerGUID, journeyGUID, appointmentTypeId, serviceId, serviceTypeId, calendarIds,selectedSlot,selectedDate, questionAnswerDict) {

    if(useMock){
      return Promise.resolve(() =>
      {
        return [...Array(6).keys()].map(x=>{
          const id = ++x;
          return {
              id,
              name:`serviceType ${id}`,
              publicName:`serviceType ${id}`,
            }
        })

      })
    }

    const clientStateData = {}

    if (locationId) clientStateData.unitId = locationId;
    if (customerGUID) clientStateData.customerGUID = customerGUID;
    if (questionAnswerDict) clientStateData.questionAnswerDict = questionAnswerDict;
    if (appointmentTypeId) clientStateData.appointmentTypeId = appointmentTypeId;
    if (serviceId) clientStateData.serviceId = serviceId;
    if (serviceTypeId) clientStateData.serviceTypeId = serviceTypeId;
    if (calendarIds) clientStateData.calendarIds = calendarIds;
    if (selectedSlot) clientStateData.selectedSlot = selectedSlot;
    if (selectedDate) clientStateData.selectedDate = selectedDate;
    const params = {};

    if (journeyGuid) params.journeyGUID = journeyGUID
    if (lngCode) params.lngCode = lngCode;
    params.clientStateData = clientStateData ? clientStateData : null

    const headers = (!!rcaEnabled && hasRecaptcha && getRecaptchaToken( await executeRecaptcha('serviceTypes') )) || {};

    const response = await POST(`${baseApi}/servicetypes/findservicetypes`,  params , headers )

    if (response.clientStateData && !isEqual(response.clientStateData, currentClientStateData)) {
      clientStateDataUpdate(response.clientStateData);
    }
    return response.serviceTypes.map((service) => {
      return {
        id: service.serviceTypeId,
        name: service.serviceTypePublicName || service.serviceTypeName,
        publicName: service.serviceTypePublicName,
      };
    })
  }


  async function getAppointmentTypes(hasRecaptcha, journeyGUID, serviceTypeId, locationId, customerGUID, appointmentTypeId, serviceId, calendarIds, selectedSlot, selectedDate, questionAnswerDict ) {
    if(useMock){
      return Promise.resolve(() =>
      {
        return [...Array(6).keys()].map(x=>{
          const id = ++x;
          return {
              id,
              name:`appointmentType ${id}`,
              publicName:`appointmentType ${id}`,
            }
        })
      })
    }
    const clientStateData = {}

    if (locationId) clientStateData.unitId = locationId;
    if (appointmentTypeId) clientStateData.appointmentTypeId = appointmentTypeId;
    if (serviceTypeId) clientStateData.serviceTypeId = serviceTypeId;
    if (customerGUID) clientStateData.customerGUID = customerGUID
    if (questionAnswerDict) clientStateData.questionAnswerDict = questionAnswerDict;
    if (serviceId) clientStateData.serviceId = serviceId;
    if (calendarIds) clientStateData.calendarIds = calendarIds;
    if (selectedSlot) clientStateData.selectedSlot = selectedSlot;
    if (selectedDate) clientStateData.selectedDate = selectedDate;

    const params = {};

    if (journeyGUID) params.journeyGUID = journeyGUID
    if (lngCode) params.lngCode = lngCode;

    params.clientStateData = clientStateData ? clientStateData : null

    const headers = (!!rcaEnabled && hasRecaptcha && getRecaptchaToken( await executeRecaptcha('appointmentTypes') )) || {};

    const response = await POST(`${baseApi}/appointmenttypes/findappointmenttypes`,  params, headers )

    if (response.clientStateData && !isEqual(response.clientStateData, currentClientStateData)) {
      clientStateDataUpdate(response.clientStateData);
    }
    return response.appointmentTypes.map((appointment) => {
      const { appointmentTypeId, appointmentTypePublicName, appointmentTypeName } = appointment;
      return {
        id: appointmentTypeId,
        name: appointmentTypePublicName || appointmentTypeName,
        publicName: appointmentTypePublicName,
      };
    })
  }
};
